import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedTeamsShowIssuesRoute extends BaseRoute {}
